class PreviewController {
  videoEl = null;
  canvasEl = null;
  videoUrl = "";
  callbackFn = (_) => undefined;

  constructor() {
    this.canvasEl = document.createElement("canvas");
  }

  createVideoElement() {
    const videoEl = document.createElement("video");

    videoEl.crossOrigin = "anonymous";
    videoEl.preload = "metadata";
    videoEl.muted = true;
    videoEl.playsInline = true;

    videoEl.addEventListener("loadeddata", this.handleVideoDataLoaded);

    return videoEl;
  }

  withUrl(url) {
    this.videoUrl = url;
    return this;
  }

  handleVideoDataLoaded() {
    if (!this.videoEl || !this.canvasEl) return;

    this.canvasEl.width = this.videoEl.videoWidth;
    this.canvasEl.height = this.videoEl.videoHeight;

    const ctx = this.canvasEl.getContext("2d");

    if (!ctx) {
      this.callbackFn("./images/default_thumbnail.png");
      return;
    }

    try {
      ctx.drawImage(
        this.videoEl,
        0,
        0,
        this.canvasEl.width,
        this.canvasEl.height,
      );

      const dataUrl = this.canvasEl.toDataURL("image/jpeg");
      this.callbackFn(dataUrl);
    } catch (e) {
      this.callbackFn("./images/default_thumbnail.png");
    } finally {
      this.cleanupVideoElement();
    }
  }

  cleanupVideoElement() {
    if (!this.videoEl) return;

    this.videoEl.pause();
    this.videoEl.removeAttribute("src");
    this.videoEl.load();
    this.videoEl.removeEventListener("loadeddata", this.handleVideoDataLoaded);
    this.videoEl = null;
  }

  onPreviewLoaded(callback) {
    if (!this.videoUrl || !callback) return undefined;

    if (this.isYoutubeUrl()) {
      callback(this.getYoutubePreviewImage());
      return undefined;
    }

    this.callbackFn = callback;
    this.cleanupVideoElement();

    this.videoEl = this.createVideoElement();
    this.videoEl.src = this.videoUrl;
    this.videoEl.load();

    return () => {
      this.cleanupVideoElement();
    };
  }

  isYoutubeUrl() {
    return (
      this.videoUrl.includes("youtube.com") ||
      this.videoUrl.includes("youtu.be")
    );
  }

  getYoutubePreviewImage() {
    const youtubeId = this.getYouTubeVideoId(this.videoUrl);

    if (youtubeId) {
      return `https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`;
    }

    return "./images/default_thumbnail.png";
  }

  getYouTubeVideoId(url) {
    if (!url) return null;

    const match = url.match(
      /(?:youtube\.com\/(?:.*v=|embed\/|shorts\/)|youtu\.be\/)([^&?/#]+)/,
    );

    return match?.[1] || null;
  }
}

const controller = new PreviewController();

export default controller;
